<template>
    <div class="animated fadeIn is-background-gray5">
        <section class="section">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content is-mobile">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center">
                            {{ $t('home:pay_as_you_go.header') }}
                        </h3>
                    </div>
                </div>
                <div class="columns is-centered">
                    <div class="column content" style="flex: inherit">
                        <figure class="image pay-as-you-go-img" v-if="!isMobile()">
                            <img alt="Pay as you go" src="./assets/pay-as-you-go.svg" width="400" height="400">
                        </figure>
                        <figure class="image pay-as-you-go-img-mobile mobile-screen" v-else>
                            <img alt="Pay as you go" src="./assets/pay-as-you-go.svg" width="300" height="300">
                        </figure>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container">
                        <p class="is-size- small-container uptin-text-center uptin-text-center">
                            {{ $t('home:pay_as_you_go.description') }}
                        </p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container padding-top-1x uptin-text-center">
                        <router-link :to="'tariff'" class="button uptin-splash-button is-background-dark1" active-class="is-active is-active--advertiser">
                            {{ $t('home:pay_as_you_go.more_details') }}
                        </router-link>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<style lang="scss">
    .pay-as-you-go-img-mobile {
        max-width: 300px;
        min-width: 300px;
        margin: 2%;
        height: auto;

        &.position-top {
            top: -1em;
        }

        &.mobile-screen {
            max-width: 400px;
            min-width: 200px;
        }
    }

    .pay-as-you-go-img {
        max-width: 400px;
        min-width: 400px;
        margin: 2%;
        height: auto;

        &.position-top {
            top: -1em;
        }

        &.mobile-screen {
            max-width: 400px;
            min-width: 200px;
        }
    }
</style>

<script>
    export default {
        components: {
        },
        name: 'pay-as-you-go',
        methods: {
            isMobile() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            }
        }
    }
</script>
